<template>
  <section>
    <b-autocomplete
      v-if="showAutocomplete"
      v-model="name"
      field="1"
      clearable
      :key="key"
      :icon="icon"
      :size="size"
      :data="filteredDataArray"
      :placeholder="placeholder"
      @select="handleSelect"
    >
      <template #empty>No results found</template>
    </b-autocomplete>
    <b-field class="mt-3">
      <div v-if="columns">
        <b-taglist>
          <b-tag
            v-for="item in selected"
            closable
            :size="size"
            :key="item.id"
            aria-close-label="Close tag"
            @close="handleClose(item)"
          >
            {{ item[1] }}
          </b-tag>
        </b-taglist>
      </div>
      <div v-else>
        <div v-for="item in selected" :key="item">
          <b-tag
            closable
            :size="size"
            aria-close-label="Close tag"
            @close="handleClose(item)"
          >
            {{ item[1] }}
          </b-tag>
        </div>
      </div>
    </b-field>
  </section>
</template>

<script>
export default {
  props: {
    icon: String,
    chainData: Array,
    placeholder: String,
    columns: {
      type: Boolean,
      default: true,
    },
    onlyOne: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: 'is-small',
    },
  },
  data() {
    return {
      name: '',
      key: true,
    };
  },
  computed: {
    showAutocomplete() {
      return !(this.onlyOne && this.selected.length > 0);
    },
    filteredDataArray() {
      return this.chainData.filter(option => {
        const nameLowerCase = this.name.toLowerCase();
        const optionString = JSON.stringify(option[option.length - 1]);
        const optionStringLowerCase = optionString.toLowerCase();
        return optionStringLowerCase.includes(nameLowerCase);
      });
    },
  },
  mounted() {
    this.$emit('list', this.selected);
  },
  methods: {
    columnCondition(val) {
      return this.columns ? val : '';
    },
    remove(val, list) {
      const index = list.indexOf(val);

      if (index > -1) {
        list.splice(index, 1);
      }
    },
    handleClose(item) {
      this.chainData.push(item);
      this.remove(item, this.selected);
      this.$emit('list', this.selected);
    },
    handleSelect(option) {
      if (option) {
        this.selected.push(option);
        this.remove(option, this.chainData);
        this.$emit('list', this.selected);
        this.key = !this.key;
        this.name = '';
      }
    },
  },
};
</script>
